export { Tooltip, TooltipPrimitiveLight } from './src/components/Tooltip';
